// Header.tsx — الشريط العلويّ الثابت (شريط shadcn-admin): زرّ طيّ القائمة + أدوات (لغة/مستخدم).
// تخصيص الهويّة اللونيّة أصبح محصورًا في صفحة إعدادات النظام (SystemSettingsPage) فقط.
import { CircleHelp, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button';
import { LanguageSwitcher } from './LanguageSwitcher';
import { NotificationBell } from './NotificationBell';
import { UserMenu } from './UserMenu';

interface HeaderProps {
	onToggleSidebar: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps) {
	const { i18n } = useTranslation();
	const helpLabel = i18n.language === 'ar' ? 'دليل استخدام النظام' : 'System user guide';

	return (
		<header className="sticky top-0 z-30 flex h-14 items-center justify-between gap-2 border-b border-border bg-background/80 px-4 backdrop-blur">
			<div className="flex items-center gap-2">
				<Button variant="ghost" size="icon" onClick={onToggleSidebar} aria-label="toggle-sidebar">
					<Menu className="size-5" />
				</Button>
			</div>
			<div className="flex items-center gap-1">
				{/* المساعدة أوّل الأدوات وأصغرها: متاحة من كلّ شاشة، وبلا صلاحية. */}
				<Button asChild variant="ghost" size="icon" aria-label={helpLabel} title={helpLabel}>
					<Link to="/Help">
						<CircleHelp className="size-4" />
					</Link>
				</Button>
				<NotificationBell />
				<LanguageSwitcher />
				<UserMenu />
			</div>
		</header>
	);
}
